/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { ISignOffAdminRequest, ISignOffSeafarerRequest } from '../models/sign-off.model';

export class CheckForDocumentsToBeSignedOff {
  static readonly type = '[SignOff] Check For Documents To Be Signed Off';
  constructor() {}
}

export class LoadDocumentsToBeSignedOff {
  static readonly type = '[SignOff] Load Documents To Be Signed Off';
  constructor() {}
}

export class SignOffDocumentAsAdmin {
  static readonly type = '[SignOff] Sign Off Document As Admin';
  constructor(public request: ISignOffAdminRequest) {}
}

export class SignOffDocumentAsSeafarer {
  static readonly type = '[SignOff] Sign Off Document As Seafarer';
  constructor(public request: ISignOffSeafarerRequest) {}
}

export class RejectDocumentAsSeafarer {
  static readonly type = '[SignOff] Reject Document As Admin';
  constructor(
    public id: string,
    public comment: string
  ) {}
}

export class ReopenDocument {
  static readonly type = '[SignOff] Reopen Document';
  constructor(
    public plannedActivitySignOffPeriodId: string,
    public comment: string
  ) {}
}

export class CloseDocument {
  static readonly type = '[SignOff] Close Document';
  constructor(
    public plannedActivitySignOffPeriodId: string,
    public comment: string
  ) {}
}

export class RemindSeafarer {
  static readonly type = '[SignOff] Remind Seafarer';
  constructor(
    public plannedActivitySignOffPeriodId: string,
    public message: string
  ) {}
}

export class LoadSignedOffDocumentsList {
  static readonly type = '[SignOff] Load Signed Off Documents';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadSignedOffDocumentDetails {
  static readonly type = '[SignOff] Load Signed Off Document Details';
  constructor(public id: string) {}
}

export class PrintSignedOffDocumentPdf {
  static readonly type = '[SignOff] Print Signed Off Document as Pdf';
  constructor(public id: string) {}
}

export class ClearCurrentSignOff {
  static readonly type = '[SignOff] Clear current sign off';
}
